<div
  class="data-card-container"
  [ngClass]="{ 'reduce-pad': dataCard.info }"
  *ngIf="(dataCard | json) !== '{}'"
>
  <div class="delivery-header">
    <div class="header-content">
      <div class="title-section">
        <h2 class="delivery-title">{{ dataCard.title }}</h2>
        <div
          *ngIf="dataCard.titleRecord"
          class="stat-value {{
            dataCard.titleRecord.colorClass
              ? dataCard.titleRecord.colorClass
              : 'defaultColor'
          }}"
        >
          {{ dataCard.titleRecord.value }}
        </div>
      </div>
      <div class="action-section" *ngIf="dataCard.isDownload">
        <button
          pButton
          type="button"
          icon="pi pi-download"
          class="p-button-rounded p-button-text p-button-sm"
          (click)="onDownloadClick()"
          pTooltip="Download error file"
          tooltipPosition="left"
        ></button>
      </div>
    </div>
  </div>
  <hr />
  <div class="stats-container" *ngIf="dataCard.items">
    <div
      class="stats-row"
      *ngFor="let row of getItemRows(); let isLast = last"
      [class.last-row]="isLast"
    >
      <div
        class="stat-card"
        *ngFor="let item of row"
        [style.width]="isLast ? getLastRowWidth() : null"
        [style.flex]="isLast && getLastRowWidth() ? '0 0 auto' : null"
      >
        <div class="stat-label">
          {{ item.label }}
          <span
            class="info-icon"
            *ngIf="item.tooltip && item.value"
            [pTooltip]="getToolTip(item.tooltip)"
            [escape]="false"
          >
            <i class="pi pi-info-circle"></i>
          </span>
          <span
            class="info-icon"
            *ngIf="item.view"
            (click)="onViewClick(item.view)"
            (keydown)="$event.preventDefault()"
          >
            <i class="pi pi-eye"></i>
          </span>
        </div>
        <div
          class="stat-value {{
            item.colorClass ? item.colorClass : 'defaultColor'
          }} {{ item.fontSize ? item.fontSize : 'medium' }}"
          [pTooltip]="item.tooltipText || ''"
          [escape]="false"
          [style.color]="item.color ? item.color : null"
          tooltipPosition="bottom"
        >
          {{ item.value ?? "NA" }}
        </div>
        <div *ngIf="item.isDownload && item.value">
          <span
            (click)="onDownloadClick()"
            (keydown)="$event.preventDefault()"
            class="download-link"
          >
            <i class="pi pi-download"></i> Download error file
          </span>
        </div>
      </div>
    </div>
    <div class="info-text" *ngIf="dataCard.info">
      <img src="assets/svg/common/replay.svg" alt="replay" />
      <span class="recurrence-title">
        Recurrence Frequency :
        <span class="recurrence-value">{{ dataCard.info }}</span></span
      >
    </div>
  </div>
</div>
